import { z } from 'zod';
import { AlertEventSchema, WatchedAlertRuleSchema } from '../base.js';
export const GetWatchedAlertsRequestQuerySchema = WatchedAlertRuleSchema.pick({ id: true });
export const GetWatchedAlertsRequestSchema = GetWatchedAlertsRequestQuerySchema;
export const GetWatchedAlertsResponseSchema = z.object({
    alerts: AlertEventSchema.array(),
});
